import CurrencyCell from 'components/CustomGridCell/CurrencyCell';
import { AdjustmentType } from 'enums';
import { AdjustmentCategoryGridProps } from 'types';

const props: AdjustmentCategoryGridProps = {
    category: AdjustmentType.CustomerDedRepay,
    adjustmentTypes: [AdjustmentType.CustomerDedRepay],
    title: 'Customer Deduction Repay',
    dataItemKey: 'rowNumber',
    selectMode: 'multiple',
    selectionGroupField: 'customerId',
    selectionGroupTitle: 'Customer Number',
    gridColumns: [
        {
            field: 'customerId',
            title: 'Customer Number',
            filterTitle: 'text'
        },
        {
            field: 'customerName',
            title: 'Customer Name',
            filterTitle: 'text'
        },
        {
            field: 'invoiceId',
            title: 'Repay Number',
            filterTitle: 'text'
        },
        {
            field: 'paymentDate',
            title: 'Date',
            format: '{0:MMMM d, yyyy}',
            filterTitle: 'date'
        },
        {
            field: 'adjustmentAmount',
            title: 'Amount',
            cell: CurrencyCell,
            filterTitle: 'numeric'
        }
    ]
}
export default props;
